import tippy from 'tippy.js';
import debounce from 'lodash.debounce';

export const init = () => {
	const tooltipsParentElements = document.querySelectorAll('.tooltip-froala');
	const tooltips = [];

	function initTooltips() {
		tooltipsParentElements.forEach((tooltipParent) => {
			const content = tooltipParent.querySelector('.tooltip-froala__text')?.textContent;
			if (content) {
				const tooltip = tippy(tooltipParent, {
					content,
					theme: 'whiteBox',
					appendTo: () => document.body,
					touch: false,
					maxWidth: 500,
				});
				tooltips.push(tooltip);
			}
		});
		manageTooltips();
	}

	function manageTooltips() {
		if (window.innerWidth <= 999) {
			tooltips.forEach((tooltip) => tooltip.disable());
		} else {
			tooltips.forEach((tooltip) => tooltip.enable());
		}
	}

	initTooltips();
	$(window).on('resize', debounce(manageTooltips, 500));
};
